import {Component, inject, OnInit, signal} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DatePipe} from '@angular/common';
import {CompanyService} from '@services/company.service';
import {IBodaccAlert} from '@models/workspace.interface';
import {FileText, LucideAngularModule, RefreshCw} from '@shared/components/icons/google-icons';
import {NotificationService} from '@services/frontend/notification.service';

@Component({
  selector: 'app-company-veille',
  imports: [DatePipe, LucideAngularModule],
  templateUrl: './company-veille.html',
})
export class CompanyVeille implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly companyService = inject(CompanyService);
  private readonly notificationService = inject(NotificationService);

  alerts = signal<IBodaccAlert[]>([]);
  syncing = signal(false);
  private siret = '';

  protected readonly RefreshCw = RefreshCw;
  protected readonly FileText = FileText;

  ngOnInit() {
    this.siret = this.route.parent!.snapshot.paramMap.get('siret')!;
    this.load();
  }

  load() {
    this.companyService.getBodaccAlerts(this.siret).subscribe({
      next: a => this.alerts.set(a),
      error: () => this.notificationService.error('Impossible de charger les annonces', 3000),
    });
  }

  sync() {
    this.syncing.set(true);
    this.companyService.syncBodacc().subscribe({
      next: () => {
        this.syncing.set(false);
        this.notificationService.success('Synchronisation terminée', 2500);
        this.load();
      },
      error: () => {
        this.syncing.set(false);
        this.notificationService.error('Échec de la synchronisation', 3000);
      },
    });
  }

  markRead(a: IBodaccAlert) {
    if (a.read) {
      return;
    }
    this.companyService.markBodaccAlertRead(a.id).subscribe({
      next: () => this.load(),
      error: () => this.notificationService.error('Action impossible', 2000),
    });
  }

  markAllRead() {
    this.companyService.markAllBodaccRead(this.siret).subscribe({
      next: () => {
        this.notificationService.success('Toutes les annonces sont marquées comme lues', 2000);
        this.load();
      },
      error: () => this.notificationService.error('Action impossible', 2000),
    });
  }
}
